module Tapas.Bindings {
    export interface INoUiSliderArgs {
        minPrice: string;
        maxPrice: string;
        isPrivateCustomer: string;
    }
    export class NoUiSlider {
        public init(element: any, valueAccessor: () => INoUiSliderArgs, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;
            
            var nonLinearStepSlider = document.getElementById('slider-non-linear-step');
            var nonLinearStepSliderValueElement = document.getElementById('slider-non-linear-step-value');

            var urlString = window.location.href;
            var url = new URL(urlString);
            
            var priceWithVatRageParameter = url.searchParams.get("PriceWithVatRange");
            var priceWithoutVatRageParameter = url.searchParams.get("PriceWithoutVatRange");
            var minPrice = 0;
            var maxPrice = 0;
            var priceInitialHighest = document.getElementById("prices").getAttribute("data-pricehigh");

            if(priceWithVatRageParameter != null || priceWithoutVatRageParameter != null) {
                if (priceWithVatRageParameter != null) {
                    $("#prices").closest(".filterbox.accordion").addClass("active");
    
                    minPrice = parseInt(valueAccessor().minPrice);
                    maxPrice = parseInt(valueAccessor().maxPrice);
                    
                    var priceWithVatRageParameterSplit = priceWithVatRageParameter.split(",");
                    
                    if (priceWithVatRageParameterSplit[0] != null) {
                        minPrice = parseInt(priceWithVatRageParameterSplit[0]);
                    }
                    if (priceWithVatRageParameterSplit[1] != null) {
                        maxPrice = parseInt(priceWithVatRageParameterSplit[1]);
                    }
                }
            
                if (priceWithoutVatRageParameter != null) {
                    $("#prices").closest(".filterbox.accordion").addClass("active");

                    minPrice = parseInt(valueAccessor().minPrice);
                    maxPrice = parseInt(valueAccessor().maxPrice);

                    var priceWithoutVatRageParameterSplit = priceWithoutVatRageParameter.split(",");

                    if (priceWithoutVatRageParameterSplit[0] != null) {
                        minPrice = parseInt(priceWithoutVatRageParameterSplit[0]);
                    }
                    if (priceWithoutVatRageParameterSplit[1] != null) {
                        maxPrice = parseInt(priceWithoutVatRageParameterSplit[1]);
                    }
                }
            } else {
                minPrice = 0;
                maxPrice = parseInt(priceInitialHighest);
            }
            
            var priceMarginNumber = 1000;
            if (maxPrice < 1000) {
                priceMarginNumber = 0;
            }
            
            noUiSlider.create(nonLinearStepSlider, {
                start: [minPrice, maxPrice],
                range: {
                    'min': [0],
                    'max': [parseInt(priceInitialHighest)]
                },
                //step: 100,
                margin: priceMarginNumber,
                connect: true,
                format: wNumb({
                    decimals: 0,
                    thousand: '.'
                    //suffix: ' (DKK)'
                })
            });
            

            nonLinearStepSlider.noUiSlider.on('update', function (values, handle, unencoded) {
                const inputFrom = $("#slider-step-value-from");
                const inputTo = $("#slider-step-value-to");
                const priceFrom = values[0];
                const priceTo = values[1];
                inputFrom.val(priceFrom);
                inputTo.val(priceTo);
            });

            nonLinearStepSlider.noUiSlider.on('slide', function(values, handle, unencoded) {
                let minPrice = parseInt(valueAccessor().minPrice);
                let maxPrice = parseInt(valueAccessor().maxPrice);

                // Prevent first handle to go beyond maximum price
                if (handle == 0) {
                    if (unencoded[0] > maxPrice) {
                        maxPrice = maxPrice - 100;
                        nonLinearStepSlider.noUiSlider.set([maxPrice, null]);
                    }
                }
                
                // Prevent second handle to go beyond minimum price
                if (handle == 1) {
                    if (unencoded[1] < minPrice) {
                        minPrice = minPrice + 100;
                        nonLinearStepSlider.noUiSlider.set([null, minPrice]);
                    }
                }
            });

            nonLinearStepSlider.noUiSlider.on('change', function (values, handle, unencoded) {
                const firstHandle = values[0].replace(".", "");
                const secondHandle = values[1].replace(".", "");
                const isPrivateCustomer = valueAccessor().isPrivateCustomer;
                const prices = firstHandle + "," + (parseInt(secondHandle) + 10);
                
                var params = new URLSearchParams(location.search);
                
                if (isPrivateCustomer == "True" || getCookie("CustomerType") == "Privat") {
                    params.delete('PriceWithoutVatRange');
                    params.set('PriceWithVatRange', prices);
                }
                
                if (isPrivateCustomer == "False" || getCookie("CustomerType") == "Erhverv") {
                    params.delete('PriceWithVatRange');
                    params.set('PriceWithoutVatRange', prices);
                }
                
                window.location.search = params.toString();
            });

            $(".slider-step-value").on("change", function(e) {
                e.preventDefault();
                e.stopPropagation();
                
                const isPrivateCustomer = valueAccessor().isPrivateCustomer;
                var params = new URLSearchParams(location.search);
                let inputValueFrom = $("#slider-step-value-from").val().replace(".", "");
                let inputValueTo = $("#slider-step-value-to").val().replace(".", "");
                const prices = inputValueFrom + "," + (parseInt(inputValueTo) + 10);

                if (isPrivateCustomer == "True" || getCookie("CustomerType") == "Privat") {
                    params.delete('PriceWithoutVatRange');
                    params.set('PriceWithVatRange', prices);
                }
                if (isPrivateCustomer == "False" || getCookie("CustomerType") == "Erhverv") {
                    params.delete('PriceWithVatRange');
                    params.set('PriceWithoutVatRange', prices);
                }
                
                window.location.search = params.toString();
            });
            
            $(".reset-price-filter").on("click", function(e) {
                e.preventDefault();
                
                var url = window.location.href;
                var resetUrl = removeURLParameters(url, 'pricewithvatrange', 'pricewithoutvatrange');

                window.location.href = resetUrl;
                
            });

            function removeURLParameters(url, ...parameters) {
                const parsed = new URL(url);
                parameters.forEach(e => parsed.searchParams.delete(e))
                return parsed.toString()
            }

            function getCookie(name) {
                const value = `; ${document.cookie}`;
                const parts = value.split(`; ${name}=`);
                if (parts.length === 2) return parts.pop().split(';').shift();
            }
            
        }
    }
    ko.bindingHandlers['noUiSlider'] = new NoUiSlider();
}
